import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{staticClass:"navegation m-0 justify-content-center"},_vm._l((_vm.buttons1),function(button){return _c(VBtn,{key:button.title,staticClass:"bg-transparent text-center",staticStyle:{"font-size":"0.8rem"},attrs:{"color":"primary","elevation":"0","href":button.link}},[_vm._v(" "+_vm._s(button.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }